<div class="atn-ds-input-field">
  @if (labelSg()) {
    <span class="atn-ds-input-field__label"> {{ labelSg() }} </span>
  }
  <div class="ds-radio-options">
    <ng-content></ng-content>
  </div>
</div>
